/**
 * Storefront API で検索結果（新着順）を取得しグリッド表示する。
 * @param {object} cfg
 */
window.grabSearchGqlInit = function (cfg) {
  var shared = window.grabSearchStorefrontShared;
  if (!window.__grabSearchGqlInited) {
    window.__grabSearchGqlInited = {};
  }
  if (window.__grabSearchGqlInited[cfg.sectionId]) {
    return;
  }
  window.__grabSearchGqlInited[cfg.sectionId] = true;

  const root = document.getElementById('ProductGridContainer-' + cfg.sectionId);
  if (!root) {
    return;
  }

  const loadingEl = root.querySelector('[data-grab-search-gql-loading]');
  const errorEl = root.querySelector('[data-grab-search-gql-error]');
  const configMissingEl = root.querySelector('[data-grab-search-gql-config-missing]');
  const collectionEl = root.querySelector('[data-grab-search-gql-collection]');
  const gridEl = root.querySelector('[data-grab-search-gql-grid]');
  const paginationEl = root.querySelector('[data-grab-search-gql-pagination]');
  const countEl = document.querySelector('.grab-search-page-counter');

  function trailKey() {
    const p = new URLSearchParams(window.location.search);
    p.delete('gql_after');
    const keys = Array.from(p.keys()).sort();
    const pairs = [];
    keys.forEach(function (k) {
      p.getAll(k).forEach(function (v) {
        pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      });
    });
    return 'grabGqlCursorTrail:' + window.location.pathname + '?' + pairs.join('&');
  }

  function getTrail() {
    try {
      return JSON.parse(sessionStorage.getItem(trailKey()) || '[]');
    } catch (e) {
      return [];
    }
  }

  function setTrail(arr) {
    sessionStorage.setItem(trailKey(), JSON.stringify(arr));
  }

  function parseSearchParams() {
    const p = new URLSearchParams(window.location.search);
    const q = (p.get('q') || '').trim();
    const tags = p.getAll('filter.p.tag');
    const availability = p.get('filter.v.availability');
    const gqlAfter = p.get('gql_after') || '';
    return { q: q, tags: tags, availability: availability, gqlAfter: gqlAfter };
  }

  function renderProductCard(node) {
    return shared.renderProductCard(node, {
      soldOutLabel: cfg.soldOutLabel,
      cardClass: 'grab-search-gql-card',
      linkClass: 'grab-search-gql-card__link',
      mediaClass: 'grab-search-gql-card__media',
      textClass: 'grab-search-gql-card__text',
      titleClass: 'grab-search-gql-card__title',
      priceRowClass: 'grab-search-gql-card__price-row',
      pricePartClass: 'grab-search-gql-card__price-part',
      compareClass: 'grab-search-gql-card__price-part--compare',
      badgeClass: 'grab-search-gql-card__badge',
      itemClass: 'grid__item',
    });
  }

  function pageHref(afterCursor) {
    const u = new URL(window.location.href);
    if (afterCursor) {
      u.searchParams.set('gql_after', afterCursor);
    } else {
      u.searchParams.delete('gql_after');
    }
    return u.toString();
  }

  function buildPaginationParts(totalPages, currentPage) {
    if (totalPages <= 1) {
      return [];
    }
    const keep = {};
    keep[1] = true;
    keep[totalPages] = true;
    keep[currentPage] = true;
    if (currentPage - 1 >= 1) {
      keep[currentPage - 1] = true;
    }
    if (currentPage + 1 <= totalPages) {
      keep[currentPage + 1] = true;
    }

    const parts = [];
    let prev = 0;
    for (let page = 1; page <= totalPages; page++) {
      if (!keep[page]) {
        continue;
      }
      if (prev > 0 && page - prev > 1) {
        parts.push({ type: 'ellipsis' });
      }
      parts.push({ type: 'page', page: page });
      prev = page;
    }
    return parts;
  }

  function renderPagination(totalCount, pageInfo, endCursor, currentPage, hasResults) {
    if (!paginationEl) {
      return;
    }
    paginationEl.innerHTML = '';
    if (!hasResults) {
      return;
    }
    const totalPages = Math.max(1, Math.ceil(totalCount / cfg.perPage));
    if (totalPages <= 1) {
      return;
    }
    const sp = parseSearchParams();
    const trail = getTrail();
    const hasPrev = currentPage > 1;
    const hasNext = !!(pageInfo && pageInfo.hasNextPage && endCursor);
    const knownPageLimit = Math.min(totalPages, currentPage + (hasNext ? 1 : 0));

    function goToPage(targetPage) {
      if (targetPage < 1 || targetPage > totalPages || targetPage === currentPage) {
        return;
      }
      const currentAfter = sp.gqlAfter || '';
      let targetAfter = '';
      let nextTrail = trail.slice();

      if (targetPage === currentPage + 1) {
        if (!hasNext) {
          return;
        }
        targetAfter = endCursor;
        nextTrail.push(currentAfter);
      } else if (targetPage === 1) {
        nextTrail = [];
      } else if (targetPage < currentPage) {
        targetAfter = trail[targetPage - 1] || '';
        nextTrail = trail.slice(0, targetPage - 1);
      } else {
        return;
      }

      setTrail(nextTrail);
      window.location.href = pageHref(targetAfter);
    }

    const ul = document.createElement('ul');
    ul.className = 'pagination__list list-unstyled';
    ul.setAttribute('role', 'list');

    if (hasPrev) {
      const liPrev = document.createElement('li');
      const aPrev = document.createElement('a');
      aPrev.href = pageHref(currentPage === 2 ? '' : trail[currentPage - 2] || '');
      aPrev.className = 'pagination__item pagination__item--next pagination__item-arrow link motion-reduce';
      aPrev.setAttribute('aria-label', '前のページ');
      aPrev.innerHTML =
        '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 10" fill="none" width="12" height="12"><path d="M13 5H1M6 1 2 5l4 4" stroke="currentColor" stroke-width="1.5"/></svg></span>';
      aPrev.addEventListener('click', function (e) {
        e.preventDefault();
        goToPage(currentPage - 1);
      });
      liPrev.appendChild(aPrev);
      ul.appendChild(liPrev);
    }

    buildPaginationParts(totalPages, currentPage).forEach(function (part) {
      const li = document.createElement('li');
      if (part.type === 'ellipsis') {
        const span = document.createElement('span');
        span.className = 'pagination__item';
        span.textContent = '…';
        li.appendChild(span);
        ul.appendChild(li);
        return;
      }

      const pageNumber = part.page;
      if (pageNumber === currentPage) {
        const current = document.createElement('a');
        current.setAttribute('role', 'link');
        current.setAttribute('aria-disabled', 'true');
        current.className = 'pagination__item pagination__item--current light';
        current.setAttribute('aria-current', 'page');
        current.setAttribute('aria-label', 'ページ ' + pageNumber);
        current.textContent = String(pageNumber);
        li.appendChild(current);
        ul.appendChild(li);
        return;
      }

      if (pageNumber <= knownPageLimit) {
        const link = document.createElement('a');
        let hrefAfter = '';
        if (pageNumber === currentPage + 1) {
          hrefAfter = endCursor;
        } else if (pageNumber > 1) {
          hrefAfter = trail[pageNumber - 1] || '';
        }
        link.href = pageHref(hrefAfter);
        link.className = 'pagination__item link';
        link.setAttribute('aria-label', 'ページ ' + pageNumber);
        link.textContent = String(pageNumber);
        link.addEventListener('click', function (e) {
          e.preventDefault();
          goToPage(pageNumber);
        });
        li.appendChild(link);
      } else {
        const span = document.createElement('span');
        span.className = 'pagination__item';
        span.textContent = String(pageNumber);
        li.appendChild(span);
      }

      ul.appendChild(li);
    });

    if (hasNext) {
      const liNext = document.createElement('li');
      const aNext = document.createElement('a');
      aNext.href = pageHref(endCursor);
      aNext.className = 'pagination__item pagination__item--prev pagination__item-arrow link motion-reduce';
      aNext.setAttribute('aria-label', '次のページ');
      aNext.innerHTML =
        '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 10" fill="none" width="12" height="12"><path d="M1 5h12M8 1l4 4-4 4" stroke="currentColor" stroke-width="1.5"/></svg></span>';
      aNext.addEventListener('click', function (e) {
        e.preventDefault();
        goToPage(currentPage + 1);
      });
      liNext.appendChild(aNext);
      ul.appendChild(liNext);
    }

    const nav = document.createElement('nav');
    nav.className = 'pagination';
    nav.setAttribute('role', 'navigation');
    nav.appendChild(ul);
    const wrap = document.createElement('div');
    wrap.className = 'pagination-wrapper';
    wrap.appendChild(nav);
    paginationEl.appendChild(wrap);
  }

  function updateResultCount(totalCount) {
    if (!countEl) {
      console.warn(`countEl not found`);
      return;
    }
    const safeCount = Number.isFinite(totalCount) ? totalCount : 0;
    countEl.textContent = safeCount + '件';
  }

  function showState(state) {
    if (loadingEl) {
      loadingEl.hidden = state !== 'loading';
    }
    if (errorEl) {
      errorEl.hidden = state !== 'error';
    }
    if (configMissingEl) {
      configMissingEl.hidden = state !== 'config';
    }
    if (collectionEl) {
      collectionEl.hidden = state !== 'ready';
    }
  }

  async function run() {
    if (!shared) {
      if (errorEl) {
        errorEl.textContent = '検索共通スクリプトの読み込みに失敗しました。';
      }
      showState('error');
      return;
    }
    if (!cfg.token) {
      showState('config');
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get('sort_by') || 'created-descending';
    if (sortBy === 'price-ascending') {
      sortKey = 'PRICE';
      reverse = false;
    }
    else if (sortBy === 'price-descending') {
      sortKey = 'PRICE';
      reverse = true;
    }
    else {
      sortKey = 'CREATED_AT';
      reverse = true;
    }

    const sp = parseSearchParams();
    const storefrontQuery = shared.buildStorefrontQuery(sp);
    const storefrontCountQuery = shared.buildStorefrontCountQuery(sp);
    const storefrontFilters = shared.buildStorefrontFilters(sp);
    const variables = {
      query: storefrontQuery,
      first: cfg.perPage,
      sortKey: sortKey,
      reverse: reverse,
    };
    if (sp.gqlAfter) {
      variables.after = sp.gqlAfter;
    }

    showState('loading');
    if (errorEl) {
      errorEl.textContent = '';
    }

    try {
      const responses = await Promise.all([
        shared.fetchStorefront(cfg, shared.PRODUCTS_QUERY, variables),
        shared.fetchStorefront(cfg, shared.PRODUCTS_COUNT_QUERY, {
          query: storefrontCountQuery,
          filters: storefrontFilters,
        }),
      ]);
      const productsData = responses[0];
      const countData = responses[1];

      const data = productsData && productsData.products;
      const totalCount = Number(
        (countData && countData.search && countData.search.totalCount) ||
        (countData && countData.productsCount) ||
        0
      );
      if (!data) {
        throw new Error('Invalid response');
      }
      const edges = data.edges || [];
      const pageInfo = data.pageInfo;
      const trail = getTrail();
      let pageIndex = 0;
      if (sp.gqlAfter) {
        pageIndex = Math.max(trail.length, 1);
      }

      if (edges.length === 0) {
        gridEl.innerHTML =
          '<li class="grid__item" style="grid-column: 1 / -1;">' +
          '<div class="collection collection--empty page-width">' +
          '<div class="title-wrapper center"><h2 class="title title--primary">商品が見つかりません</h2></div>' +
          '</div></li>';
        if (paginationEl) {
          paginationEl.innerHTML = '';
        }
        updateResultCount(totalCount);
        showState('ready');
        return;
      }

      gridEl.innerHTML = edges
        .map(function (e) {
          return renderProductCard(e.node);
        })
        .join('');
      const endCursor = pageInfo && pageInfo.endCursor ? pageInfo.endCursor : '';
      renderPagination(totalCount, pageInfo, endCursor, pageIndex + 1, true);
      updateResultCount(totalCount);
      showState('ready');
    } catch (err) {
      console.error('grab-search-gql', err);
      if (errorEl) {
        errorEl.textContent =
          (err && err.message) || '検索の読み込みに失敗しました。';
      }
      showState('error');
    }
  }

  run();
};
